import { Stack } from "~/common/mui";
import { type ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import type { LineItem, ResolvedGroupedCartEntry } from "~/features/cart/cart/models/CartData";
import type { ReactNode } from "react";

interface ProductLineListProps {
  packGroups: ResolvedGroupedCartEntry["packGroups"];
  product: ProductDescriptor;
  renderItem: (lineItem: LineItem, product: ProductDescriptor) => ReactNode;
}

export const ProductLineList = ({ packGroups, product, renderItem }: ProductLineListProps) => {
  const lineItems = packGroups.flatMap((group) => group.packEntries);
  return <Stack spacing={2}>{lineItems.map((lineItem) => renderItem(lineItem, product))}</Stack>;
};
